import { t } from '@transifex/native';

import type { Attachment } from 'pkg/api/models/attachment';
import { AttachmentType } from 'pkg/api/models/attachment';

export function getHumanFileSize(a: Attachment): string {
	return humanFileSize(a.size);
}

/** A byte count as it reads: `820KB`. For a file that isn't an attachment yet. */
export function humanFileSize(bytes: number): string {
	const sizes = ['B', 'KB', 'MB', 'GB'];

	if (!(bytes > 0)) {
		return `0${sizes[0]}`;
	}

	let y = Math.min(
		sizes.length - 1,
		Math.floor(Math.log(bytes) / Math.log(1000))
	);

	// 999,600 bytes rounds up to the next unit: 1MB, never 1000KB.
	if (Math.round(bytes / Math.pow(1000, y)) >= 1000 && y < sizes.length - 1) {
		y += 1;
	}

	return `${Math.round(bytes / Math.pow(1000, y))}${sizes[y]}`;
}

export function getTypeTranslation(type: string) {
	switch (type) {
		case AttachmentType.Audio:
			return t('Audio');
		case AttachmentType.File:
			return t('File');
		case AttachmentType.Image:
			return t('Image');
		case AttachmentType.Video:
			return t('Video');
		case AttachmentType.Voice:
			return t('Voice message');
		default:
			return type;
	}
}
